import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, connect, ConnectedProps } from 'react-redux';
import Modal from 'Components/UI/Modal';
import ArmazenamentoTab from '../../components/Tabs/ArmazenamentoTab';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { Skeleton } from 'antd';
import Button from 'Components/UI/Button';
import { IUpdateConstructionSiteApiRequest } from 'Data/interfaces/Obra/IUpdateConstructionSiteApiRequest';
import toastHandler from 'Utils/toastHandler';
import { SkeletonContainer } from './styles';
import { useQueryUpdateApiObra } from 'Hooks/obras/useQueryUpdateApiObra';

interface IConexaoServico {
  csId?: number;
  isVisible?: boolean;
  isRedirect?: boolean;
  accountIdSelected?: number;
  onCancel?: () => void;
}

const ConexaoServico: FC<Props> = ({
  isVisible,
  AccountsInfo,
  csId,
  isRedirect,
  accountIdSelected,
  onCancel,
}) => {
  const { t } = useTranslation('obras');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { updateApiObra, isLoading } = useQueryUpdateApiObra({
    dispatch,
    navigate
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSendingData, setSendingData] = useState<boolean>(false);

  if (isSendingData && !isLoading) {
    setSendingData(false);
    if (onCancel) {
      onCancel();
    }
  }

  const onSubmit = (values: any) => {
    if (csId && values !== undefined) {
      const request: IUpdateConstructionSiteApiRequest = {
        CsId: csId,
        Api: values.Api,
        ExistingConstructionSiteTokenId: values.ExistingConstructionSiteTokenId,
        isRedirect: isRedirect === undefined ||
          isRedirect ||
          !values.ExistingConstructionSiteTokenId,
      };
      updateApiObra(request);
      setSendingData(true);
    } else {
      toastHandler.showError(t('conexaoServico.noServiceSelected'));
    }
    setIsSubmitted(false);
  };

  useEffect(() => {
    if (isVisible) {
      dispatch(ObraActions.listConstructionSiteAccounts());
    }
  }, [dispatch, isVisible]);

  const footerButtons = (
    <>
      <Button onClick={onCancel}>
        <span style={{ padding: '0 35px' }}>{t('conexaoServico.cancel')}</span>
      </Button>
      <Button
        type='primary'
        loading={isLoading}
        onClick={() => setIsSubmitted(true)}
      >
        <span style={{ padding: '0 35px' }}>{t('conexaoServico.finish')}</span>
      </Button>
    </>
  );

  return (
    <Modal
      title={t('conexaoServico.modalTitle')}
      visible={isVisible}
      onCancel={onCancel}
      width={800}
      footerButtons={footerButtons}
      maskClosable={false}>
      {isLoading ? (
        <SkeletonContainer><Skeleton active /></SkeletonContainer>
      ) : (
        <ArmazenamentoTab
          onSubmit={onSubmit}
          accountsInfo={AccountsInfo}
          isSubmited={isSubmitted}
          accountIdSelected={accountIdSelected}
        />
      )}
    </Modal>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  AccountsInfo: state.obra.AccountsInfo,
});

const connector = connect(
  mapState,
);

type Props = ConnectedProps<typeof connector> & IConexaoServico;

export default connector(ConexaoServico);
